// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomIconButton_button__nHb2s","iconContainer":"CustomIconButton_iconContainer__JkE85"};